<template>
    <div>
        <el-dialog 
            :visible.sync="$store.state.isShowDemoDialog" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false" 
            custom-class="custom-dialog">
            <div slot="title" class="postion">
                <img v-lazy="iconObj.float_icon_demo" alt="" />
                <span class="download">{{ $t('index.btn_demo_show') }}</span>
            </div>

            <div class="qr-area">
                <div class="down-area">
                    <div class="qr-code">
                        <img v-lazy="iconObj.qr_android" alt="" />
                    </div>
                    <div class="qr-tips">
                        <div>
                            <img v-lazy="iconObj.icon_google_play" alt="" />
                        </div>
                        <div>
                            <p style="display:none;">{{ $t('index.right_pop.download_tips') }}</p>
                            <p>{{ $t('index.right_pop.download_android') }}</p>
                        </div>
                    </div>
                </div>

                <div class="down-area-line-box">
                    <div class="down-area-line"></div>
                </div>

                <div class="down-area">
                    <div class="qr-code">
                        <img v-lazy="iconObj.qr_ios" alt="" />
                    </div>
                    <div class="qr-tips">
                        <div>
                            <img v-lazy="iconObj.icon_ios" alt="" />
                        </div>
                        <div>
                            <p style="display:none;">{{ $t('index.right_pop.download_tips') }}</p>
                            <p>{{ $t('index.right_pop.download_ios') }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tel-area" v-if="false">
                <div class="postion">
                    <img v-lazy="iconObj.icon_tel" alt="" />
                    <span class="download">{{ $t('index.right_pop.contact_us_tel_tips') }}</span>
                </div>
                <div class="tel-account">
                    {{ $t('index.right_pop.contact_us_tel')  }}
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getDemoQrCodeImages } from '@/utils/qrCodeConfig';

export default {
    name: 'DemoDialogPc',
    data() {
        return {
            tips   : 'Hello World',
            iconObj: {
				float_icon_demo : require('@/assets/static/imgs/common/float_icon_demo.png'),
				...getDemoQrCodeImages(),
				icon_google_play: require('@/assets/static/imgs/common/icon-google-play.png'),
				icon_ios        : require('@/assets/static/imgs/common/icon-ios.png'),
				icon_tel        : require('@/assets/static/imgs/common/icon-tel.png')
			}
        }
    },
	methods: {
		handleError(event)
        {
            /* console.log('event >>>', event);
            event.target.src = require('@/assets/static/imgs/common/google-cloud.png'); */
        }
	}
}
</script>

<style lang="less" scoped>
/deep/ .custom-dialog{
	/* overflow:scroll !important; *//* 恢复页面滚动 */
	/* padding-right:0 !important; *//* 移除右侧填充 */
	/* 385px */
	width:540px;height:325px;
	border-radius:25px !important;
	.postion{
		display:flex;justify-content:flex-start;align-items:center;
		img{
			width:30px;height:30px;
			margin-right:5px;
		}
		span{
			font-size:var(--com-base-fz-18);font-weight:bold;color:var(--com-main-ft-color);
		}
	}
	.el-dialog__header{
		padding:30px 20px 0 50px;
		.el-dialog__headerbtn{
			top:20px;right:20px;
			width:32px;height:32px;
			padding:5px;
			font-size:var(--com-base-fz-16);
		}
	}
	.el-dialog__body{
		padding:20px;
		.qr-area{
			display:flex;justify-content:center;align-items:flex-start;
			gap:65px;
			.down-area-line-box{
				display:flex;justify-content:center;align-items:flex-start;
				.down-area-line{
					width:1px;height:100px;
					margin-top:10px;
					border-left:1px solid #ededed;
				}
			}
			.down-area{
				display:flex;flex-direction:column;justify-content:flex-start;align-items:center;
				.qr-code{
					width:120px;height:120px;
					img{
						width:inherit;height:inherit;
						border:1px solid #ededed;border-radius:14px;
						padding:2px;
					}
				}
				.qr-tips{
					display:flex;justify-content:flex-start;align-items:flex-start;
					width:120px;
					margin-top:15px;
					div:nth-child(1){
						width:30px;height:30px;/* height:60px; */
						margin-right:3px;
						img{
							width:inherit;height:30px;
						}
					}
					div:nth-child(2){
						display:flex;flex-direction:column;justify-content:center;align-items:flex-start;
						height:30px;/* height:60px; */
						p{
							font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-16);font-weight:bold;color:var(--com-main-ft-color);
							line-height:20px;
							&:nth-child(1){
								font-weight:normal;color:#ADB2BC;
							}
						}
					}
				}
			}
			.down-right{
				font-size:12px;
			}
		}
		.tel-area{
			padding-left:30px;margin-top:25px;
			.postion{
				text-align:left;
			}
			.tel-account{
				padding-left:35px;
				font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-18);color:#1D55FF;font-style:italic;
			}
		}
	}
}
</style>
